import { styled } from "styled-components";

export const ModalMask = styled.div`
  position: fixed;
  inset: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(112, 118, 135, 0.16);
  z-index: 999;
`;

export const ModalAnimation = styled.div`
  display: flex;
  justify-content: center;
  align-items: ${({ isMobile }) => (isMobile ? "flex-end" : "center")};
  position: fixed;
  inset: 0;
  z-index: 1000;

  .fadeIn {
    @keyframes slideInFromDown {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(0);
      }
    }
    animation: 0.5s ease-out 0s 1 slideInFromDown;

    @media (min-width: 768px) {
      @keyframes scaleIn {
        0% {
          transform: scale(0.95);
          opacity: 0;
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
      animation: scaleIn 0.3s ease-out;
    }
  }

  .fadeOut {
    @keyframes slideOut {
      0% {
        transform: translateY(0);
      }
      100% {
        transform: translateY(100%);
      }
    }
    animation: 0.2s ease-in 0s 1 slideOut;

    @media (min-width: 768px) {
      @keyframes scaleOut {
        0% {
          transform: scale(1);
          opacity: 1;
        }
        100% {
          transform: scale(0.95);
          opacity: 0;
        }
      }
      animation: scaleOut 0.2s ease-in;
    }
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 20px;
  width: 100%;
  max-width: ${({ isMobile }) => (isMobile ? "100%" : "480px")};
  position: ${({ isMobile }) => (isMobile ? "fixed" : "static")};
  bottom: ${({ isMobile }) => (isMobile ? "0" : "auto")};
  top: ${({ isMobile }) => (isMobile ? "auto" : "50%")};
  transform: translateX(-50%)
    ${({ isMobile }) => (isMobile ? "" : "translateY(-50%)")};
  z-index: 1000;
  height: auto;
  margin: auto;

  &.fadeIn {
    animation: slideIn 0.4s ease-out forwards;
  }

  &.fadeOut {
    animation: slideOut 0.3s ease-in forwards;
  }

  @keyframes slideIn {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0%);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateY(0%);
      opacity: 1;
    }
    to {
      transform: translateY(100%);
      opacity: 0;
    }
  }

  @media (min-width: 768px) {
    top: 50%;
    bottom: auto;
    transform: translate(-50%, -50%);
    border-radius: 16px;
  }
`;

export const ModalLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px;
  border-radius: 20px 20px 0 0;
  border-bottom: ${(props) =>
    props.label && "1px solid rgba(124, 127, 134, 0.20)"};
  .label {
    color: #171725;
    font-feature-settings: "clig" off, "liga" off;
    font-family: Satoshi-Variable;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.1px;
  }
  .icon {
    width: 24px;
    display: flex;
    align-items: center;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  z-index: 1500;
`;
